import dayjs from "dayjs";
import * as y from "yup";

export const TimelinesSchema = y.object({
  timezone: y.string().required(),
  announce_at: y
    .date()
    .required("Please set the date for the event to be visible")
    .when(["timezone", "on_sale_at"], ([timezone, onSaleAt], schema) => {
      if (!onSaleAt) return schema;

      const d_onSaleAt = dayjs(onSaleAt);

      return schema.max(
        d_onSaleAt.toDate(),
        "Needs to be before on sale date."
      );
    }),
  on_sale_at: y
    .date()
    .nullable()
    .when(["timezone", "off_sale_at"], ([timezone, offSaleAt], schema) => {
      if (!offSaleAt) return schema;

      const d_offSaleAt = dayjs(offSaleAt);

      return schema.max(d_offSaleAt.toDate(), "Must be before off sale date.");
    }),
  off_sale_at: y
    .date()
    .nullable()
    .when(["timezone", "end_at"], ([timezone, endAt], schema) => {
      if (!endAt) return schema;
      const d_endAt = dayjs(endAt);

      return schema.max(
        d_endAt.toDate(),
        "Off sale date needs to be before the end of the event."
      );
    }),
  doors_at: y
    .date()
    .nullable()
    .when(["timezone", "start_at"], ([timezone, startAt], schema) => {
      if (!startAt) return schema;

      const d_startAt = dayjs(startAt);

      return schema
        .min(
          d_startAt.subtract(3, "days").toDate(),
          "Doors should open at maximum 3 days before the event starts"
        )
        .max(
          d_startAt.toDate(),
          "Doors can not open after the event has started"
        );
    }),
  start_at: y
    .date()
    .required("Please set the start date of the event")
    .when(
      ["timezone", "end_at", "announce_at"],
      ([timezone, endAt, announceAt], schema) => {
        if (!endAt || !announceAt) return schema;

        const d_endAt = dayjs(endAt);
        const d_announceAt = dayjs(announceAt);

        return schema
          .min(d_announceAt.toDate(), "Start has to be after announcement date")
          .max(d_endAt.toDate(), "Start has to be before end date");
      }
    ),
  end_at: y.date().required("Please set the end date of the event"),
});
